import { RevocableStandaloneToken, UserRoleSet } from '@paragon/contract-library';

import { UserService } from '../connections';

export async function generateStandaloneToken(roleSet: UserRoleSet, customClaims: object) {
  return UserService.post<{ readonly token: string; readonly guid: string }>('tokens/standalone', {
    data: { ...customClaims, roleSet },
  }).then((response: any) => ({ token: response.token, guid: response.user.customClaims.revocationGuid }));
}

export async function getStandaloneTokensForStation(stationGuid: string): Promise<RevocableStandaloneToken[]> {
  return UserService.get(`tokens/standalone/${stationGuid}`);
}

export async function revokeStandaloneToken(guid: string): Promise<void> {
  return UserService.delete(`tokens/standalone/${guid}`);
}
